module.exports = __webpack_public_path__ + "static/media/3.50d4a493.png";